import { ascDefaultTheme, Theme } from '@amsterdam/asc-ui';

const theme: Theme.ThemeInterface = {
	...ascDefaultTheme,
};

export default theme;
